import type { SVGProps } from 'react'
const SvgSySynotechIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 283.5" width={24} height={24} {...props}>
		<polygon points="135.4 96.7 178.4 78.2 178.4 8.2 50.5 63.2 50.5 133.1 135.4 96.7" />
		<polygon points="233 135 144.3 100.2 51.8 133.6 143.1 169.6 233 204.9 233 135" />
		<polygon points="133.8 173.3 50.5 205.3 50.5 275.2 231.5 205.5 133.8 173.3" />
	</svg>
)
export default SvgSySynotechIcon
